// extracted by mini-css-extract-plugin
module.exports = {"overlay":"AffordableCarsCard_overlay__B25Tg","slotMachine":"AffordableCarsCard_slotMachine__i9cDl","fadeIn":"AffordableCarsCard_fadeIn__xIyTq"};